import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    height: '100%',
  },
  gridContainer: {
    display: 'flex',
    height: '100%',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(2),
  },
  chartContainer: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },
  scrollbar: {
    maxHeight: '100%',
    paddingRight: theme.spacing(2),
  },
}))

export default styles
